import React from 'react';
import { Button } from 'reactstrap';
import { domainRoute, resourceListRoute, ResourceType } from '~/lib/helper/RouteHelper';

type ManageDomainsButtonProps = {
    /** The order's only domain, when it still has a page of its own; omit to link to the domain list. */
    domainName?: string;
};

/** The way out of a domain order's result page: to its domain, or to the domain list. */
export default class ManageDomainsButton extends React.Component<ManageDomainsButtonProps> {
    render() {
        const { domainName } = this.props;
        return (
            <div className="mt-4">
                {domainName ? (
                    <Button href={`${domainRoute(domainName)}/registration`} color="primary">
                        Manage Domain
                    </Button>
                ) : (
                    <Button href={resourceListRoute(ResourceType.DomainRegistration)} color="primary">
                        Manage Domains
                    </Button>
                )}
            </div>
        );
    }
}
